import React from 'react';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';

export default function StackedBar(props) {
  // const CustomTooltip = ({ active, payload, label }: any) => {
  //   if (active && payload && payload.length) {
  //     if (!label_to_show) {
  //       return null;
  //     }
  //     return (
  //       <div className="tooltip">
  //         <p className="tooltipLabel">{`${payload[0].payload[label_to_show]}`}</p>
  //       </div>
  //     )
  //   }
  //
  //   return null
  // }

  return (
    <div className='shadow-lg p-1 p-4 bg-white dark:bg-gray-800'>
     <span className="text-gray-700 dark:text-gray-100 text-left font-bold my-4">{props.title}</span>
      <ResponsiveContainer width="100%"
                           height={300}>
        <BarChart
          width={500}
          height={300}
          data={props.entities}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis dataKey={props.group_by}/>
          <YAxis/>
          <Tooltip />
          {/*<Tooltip content={<CustomTooltip/>}  />*/}
          <Legend/>
          {
            props.bars_list.map(bar =>
            <Bar dataKey={bar.name}  stackId="a" fill={bar.fill}>
              {/*<LabelList dataKey={bar.name} content={<text>{bar.label}</text>} />*/}
            </Bar>)
          }
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
